// Shared session management module — imported by webpack at build time.
//
// Creates a Session object that reads config from meta tags, manages session
// timeout warnings, and exposes rootUrl/domain/locale/csrf for other modules.
//
// Usage (in each project's webpack entry point):
//   import { createSession } from '@xolo/shared/session';
//   import Translations from './plugins/translations';
//
//   const Session = createSession({
//       onLogout: () => Utility.logout(),
//       translations: Translations
//   });
//   window.Session = Session;

import './session-timeout';

export function createSession({ onLogout, translations }) {
    const language = $("html").attr("lang"),
          supportLocaleSS = ['en', 'es', 'et', 'it', 'fr'],
          sessionTimeoutDisabled = $("meta[name='_disable_session_timeout']").attr("content");

    const locale = supportLocaleSS.includes(language) ? language : 'en';
    const t = translations[locale].SessionTimeout;

    let Session = {
        rootUrl: $("meta[name='_root_url']").attr("content"),
        domain: $("meta[name='_domain']").attr("content"),
        extendedSession: $("meta[name='_extended_session']").attr("content"),
        csrfParameter: $("meta[name='_csrf_parameter']").attr("content"),
        csrfToken: $("meta[name='_csrf']").attr("content"),
        locale: locale,
        data: {},

        init: () => {
            if (!sessionTimeoutDisabled) {
                Session.initSessionTimeout();
            }
        },

        initSessionTimeout: () => {
            $.sessionTimeout({
                title: t.title,
                message: t.message,
                logoutButton: t.logoutButton,
                keepAliveButton: t.keepAliveButton,
                warnAfter: Session.extendedSession === 'true' ? 21300000 : 3300000,
                redirAfter: Session.extendedSession === 'true' ? 21600000 : 3600000,
                keepAliveInterval: 300000,
                ignoreUserActivity: true,
                keepAliveUrl: Session.rootUrl + 'keep-alive',
                ajaxData: Session.data,
                redirUrl: Session.rootUrl,
                onRedir: function () {
                    $('.countdown-holder').remove();
                    $('.modal-title').text(t.sessionExpired);
                    $('.expire-text').text(t.sessionExpired);
                    $('#session-timeout-dialog-keepalive').hide();
                    $('#session-timeout-dialog-logout').hide();
                    $('#session-timeout-dialog-ok').show();
                },
                logoutUrl: Session.rootUrl,
                onLogout: onLogout,
                countdownMessage: '{timer}',
                countdownSmart: true
            });
        }
    };

    return Session;
}
